import React from 'react'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useAuth } from '@hooks'
import { ActionTypes } from '@constants'
import {
  useClassroomQuery,
  useFileUpdate,
  useFileUpload
} from '@components/Classroom/hooks'

import Files from './Files'
import Formatter from './Formatter'
import { useFinder } from '../../hooks'
import { ClassroomManager } from '../../../../../../helpers'
import { ACTION_TYPES } from '../../contexts/FinderContext'

const Local = () => {
  const { id: appointmentId } = useParams()
  const [{ filter, query, mode }, dispatch] = useFinder()
  const { profile } = useAuth()
  const {
    data: { participants = {} }
  } = useClassroomQuery()
  const { mutateAsync: updateFile } = useFileUpdate()

  // redux:FILES
  const { files, status } = useSelector((state) => ({
    files: state.files.data,
    status: state.files.status
  }))

  const upload = useFileUpload({
    participants: [profile.id, ...Object.keys(participants)],
    onOversize: (payload) =>
      dispatch({ type: ACTION_TYPES.UPDATE_OVERSIZE, payload }),
    defaultBody: appointmentId
      ? {
          appointment: appointmentId
        }
      : {}
  })

  const open = (file) => {
    switch (file.type) {
      case 'sketch':
      case 'note':
      case 'code':
        if (mode === 'viewer')
          return dispatch({
            type: ACTION_TYPES.UPDATE_FILE,
            payload: file
          })
        if (!ClassroomManager.getPanels().includes(file.type))
          ClassroomManager.openPanel(file.type)
        ClassroomManager.openFile({
          id: file.id,
          type: file.type,
          name: file.name
        })
        break
      default:
        if (mode === 'viewer')
          return dispatch({ type: ACTION_TYPES.UPDATE_FILE, payload: file })
        ClassroomManager.activateFile({ ...file, type: 'finder' })
        break
    }
  }

  const loadFile = (file) => {
    const participantIdsToAdd = Object.keys(participants).reduce(
      (acc, key) =>
        file.participants.find((p) => p.id === key) ? acc : [...acc, key],
      []
    )

    if (participantIdsToAdd.length) {
      updateFile({
        id: file.id,
        data: {
          participants: {
            action: 'add',
            value: participantIdsToAdd
          }
        }
      }).then(() => open(file))
    } else {
      open(file)
    }
  }

  return (
    <Formatter data={files} filter={filter} query={query}>
      {(data) => (
        <Files
          data={data}
          upload={upload}
          loadFile={(file) => loadFile(file)}
          loading={status === ActionTypes.STATUS.PENDING}
        />
      )}
    </Formatter>
  )
}

export default Local
